<template>
    <li v-if="!loading" class="TeamChallengeResult">
        <div class="left-side">
            <img src="@/assets/images/theory_image.png" />
            <div class="headers-wrapper">
                <h4>{{ $t(`dashboard.general.lifeskillLabels.${course.lifeskillNumber}`) }}</h4>
                <h2>{{ journey.name }}</h2>
            </div>
        </div>
        <div class="right-side">
            <div v-if="gameTopPlayer" class="top-game-player">
                <h5>TOP Game</h5>
                <div class="avatar-and-name">
                    <img class="golden-rank-icn" src="@/assets/images/golden-rank-icn.png" alt="golden-rank-icon" />
                    <img src="https://picsum.photos/200" :alt="gameTopPlayer.lastName" />
                    <p>{{ gameTopPlayer.firstName }} {{ gameTopPlayer.lastName || '' }}</p>
                </div>
            </div>

            <div class="top-quiz-player">
                <h5>TOP Quiz</h5>
                <div class="avatar-and-name">
                    <img class="golden-rank-icn" src="@/assets/images/golden-rank-icn.png" alt="golden-rank-icon" />
                    <img src="https://picsum.photos/200" :alt="quizTopPlayer.lastName" />
                    <p>{{ quizTopPlayer.firstName }} {{ quizTopPlayer.lastName || '' }}</p>
                </div>
            </div>

            <div class="leaderboards">
                <button v-if="gameLeaderBoard.length" @click="openLeaderBoardPopup(teamGoal.memoGameId)">
                    Game Leaderboard
                </button>
                <button v-if="quizLeaderBoard.length" @click="openLeaderBoardPopup(teamGoal.quizGameId)">
                    Quiz Leaderboard
                </button>
            </div>
        </div>
    </li>
</template>

<script>
import { mapGetters } from 'vuex';
import LeaderBoard from '@/modules/dashboard/views/TeamChallenge/LeaderBoard';

export default {
    props: {
        teamGoal: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            gameLeaderBoard: [],
            quizLeaderBoard: [],
            loading: true
        };
    },

    computed: {
        ...mapGetters({
            getJourneyById: 'moduleCourse/getJourneyById'
        }),

        teamGoalQuiz() {
            return this.$store.getters['moduleMemoransier/games'].find(game => game.id === this.teamGoal.quizGameId);
        },

        course() {
            return this.$store.state.moduleCourse.courses[this.journey?.courseId];
        },

        journey() {
            return this.getJourneyById(this.teamGoal?.journeyId);
        },

        gameTopPlayer() {
            return this.gameLeaderBoard && this.gameLeaderBoard.length && this.gameLeaderBoard[0];
        },

        quizTopPlayer() {
            return this.quizLeaderBoard && this.quizLeaderBoard.length && this.quizLeaderBoard[0];
        }
    },

    mounted() {
        this.intervalId = setInterval(async () => {
            await this.refreshLeaderBoard();
            this.loading = false;
        }, 1000);
    },

    beforeDestroy() {
        clearInterval(this.intervalId);
    },

    methods: {
        async refreshLeaderBoard() {
            if (this.teamGoal.memoGameId) {
                this.gameLeaderBoard = await this.$store.dispatch(
                    'moduleMemoransier/getLeaderboard',
                    this.teamGoal.memoGameId
                );
            }

            if (this.teamGoal.quizGameId) {
                this.quizLeaderBoard = await this.$store.dispatch(
                    'moduleMemoransier/getLeaderboard',
                    this.teamGoal.quizGameId
                );
            }
        },

        openLeaderBoardPopup(gameId) {
            this.$modal.open({
                component: LeaderBoard,
                props: {
                    gameId,
                    teamGoal: this.teamGoal
                },
                target: 'app-modal'
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.TeamChallengeResult {
    min-height: 140px;
    background: #18194c;
    box-shadow: 0px 2px 23px rgba(79, 79, 79, 0.1);
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .left-side {
        min-height: 100%;
        margin-left: 45px;
        display: flex;
        align-items: center;

        .headers-wrapper {
            margin-left: 30px;
            h4 {
                font-size: 14px;
                line-height: 22px;
                color: #758ebf;
                font-weight: normal;
                margin: 0;
            }
            h2 {
                font-weight: 500;
                font-size: 14px;
                line-height: 26px;
                color: white;
                margin: 5px 0;
            }
        }
    }

    .right-side {
        display: flex;
        align-items: center;

        .top-game-player {
            margin-right: 50px;
            h5 {
                font-style: normal;
                font-weight: bold;
                font-size: 14px;
                line-height: 15px;
                color: #48546f;
                margin-bottom: 10px;
                margin-top: 0;
            }
            .avatar-and-name {
                display: flex;
                align-items: center;
                .golden-rank-icn {
                    width: 27px;
                    height: 27px;
                    margin-right: 10px;
                }
                img {
                    width: 34px;
                    height: 34px;
                    border-radius: 50%;
                }
                p {
                    font-style: normal;
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 16px;
                    margin: 0 0 0 10px;
                    color: rgba(255, 255, 255, 0.8);
                }
            }
        }

        .top-quiz-player {
            h5 {
                font-style: normal;
                font-weight: bold;
                font-size: 14px;
                line-height: 15px;
                color: #48546f;
                margin-bottom: 10px;
                margin-top: 0;
            }
            .avatar-and-name {
                display: flex;
                align-items: center;
                .golden-rank-icn {
                    width: 27px;
                    height: 27px;
                    margin-right: 10px;
                }
                img {
                    width: 34px;
                    height: 34px;
                    border-radius: 50%;
                }
                p {
                    font-style: normal;
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 16px;
                    margin: 0 0 0 10px;
                    color: rgba(255, 255, 255, 0.8);
                }
            }
        }

        .leaderboards {
            display: flex;
            flex-direction: column;
            margin: 0 50px;
            button {
                border: none;
                background: #18194c;
                color: #40ace0;
                font-weight: 500;
                font-size: 14px;
                line-height: 19px;
                outline: none;
                cursor: pointer;
                margin: 2px 0;
            }
        }
    }
}
</style>
